import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';
import {task} from '@acng/frontend-stargazer';
import {remove} from '@acng/frontend-bounty/dom/move.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

import {createFrontendFeature} from '../../core/model/feature.js';
import {hasFeature} from '../../core/service/env.js';
import {setup} from './cache.js';

export const feature = createFrontendFeature('friend');

/**
 * Setup the friendship cache as compile task or,
 * if the friend feature is hidden, remove the element.
 *
 * @param {Element} element
 * @param {string} _value
 *
 * @param {import('@acng/frontend-stargazer').RegistryEngine} compiler
 * the update task would be added to
 *
 * @returns {boolean}
 * `true` when the cache initialization has been queued
 * `false` if the element is removed
 */
export const compile = (element, _value, compiler) => {
  if (feature[HIDDEN]) {
    DEBUG: if (debug(element)) console.log('hidden feature', {feature, element});

    remove(element);
  } else {
    task(compiler, setup());
  }

  return !feature[HIDDEN];
};

feature[HIDDEN] = !hasFeature('friend');
